
<div class="page-padding">
  <mat-card class="main-container mat-elevation-z2">
    <form [formGroup]="agentResourceForm" novalidate >      
    <mat-card-content>
      <div class="content-padding">
        <div>
          <h2><span style="color: red; font-weight: bold;"><strong>Seneca</strong></span> | International</h2>
        </div>

        <br>

        <div class="oneRowFlex">
          <span class="label1"><mat-label>Agency ID:</mat-label></span>
          <span class="label2"><mat-label>{{agencyID}}</mat-label></span>
        </div>

        <div class="oneRowFlex">
          <span class="label1"> <label>Agency Name:</label></span>
          <span class="label2"><mat-label>{{getControlLabel('companyNameCtrl')}}</mat-label></span>
        </div>  

        <div class="oneRowFlex">
          <span class="label1"><mat-label>Agent Name:</mat-label></span>
          <span class="label2"><mat-label>{{getControlLabel('agentNameListCtrl')}}</mat-label></span>
        </div>  
        <br>
        <hr />
        <div>
          <p class="table-headers"> Commission Information</p>
          <div class="contentTable">
            <table >
              <tr>
                <td>Status</td>
                <td><label>{{getControlLabel('commissionStatusCtrl')}}</label></td>
              </tr>

              <tr>
                <td>Commission Amount</td>
                <td><label>$ CAD {{getControlLabel('commissionAmountCtrl')}}</label></td>
              </tr>                   

              <tr>
                <td>Tuition Amount</td>
                <td><label>$ CAD {{getControlLabel('tuitionAmountCtrl')}}</label></td>
              </tr>

              <tr>
                <td>Term</td>
                <td>
                  <label>{{getControlLabel('termCtrl')}}</label>                           
              </td>
              </tr>

              <tr>
                <td>Student Last Name, First Name</td>
                <td>
                  <label>{{getControlLabel('studentNameCtrl')}}</label>                           
              </td>
              </tr>

              <tr>
                <td>Application Number</td>
                <td>{{applicationID}}</td>
              </tr>

              <tr>
                <td>Student Number</td>
                <td>
                    <label>{{getControlLabel('studentNumberCtrl')}}</label>                           
                </td>
              </tr>

              <tr>
                <td>Program Name (Code)</td>
                <td>
                  <label>{{getControlLabel('programNameCtrl')}}</label>                           
                </td>              
              </tr>

              <tr>
                <td>Campus</td>
                <td><label>{{getControlLabel('campusCtrl')}}</label></td>
              </tr>

              <tr>
                <td>Student Country</td>
                <td>
                  <span class="label2"><mat-label>{{getControlLabel('countryNameCtrl')}}</mat-label></span>
                </td>
              </tr>

              <tr>
                <td>Date Submitted</td>                
                <td>
                  <span class="label2"><mat-label>{{getControlLabel('submittedDateCtrl')}}</mat-label></span>
                </td>
              </tr>

              <tr>
                <td>Agent Dispute Comments</td>                
                <td>
                  <span class="label2"><mat-label>{{getControlLabel('disputtedCommentsCtrl')}}</mat-label></span>
                </td>
              </tr>
                          
            </table>

            <p class="table-headers">Payment Details</p>

            <table>
              <!--
                <tr>
                <td>Payment Method</td>
                <td>
                  <span class="label2"><mat-label>{{getControlLabel('paymentDescriptionCtrl')}}</mat-label></span>
                </td>
              </tr>
              -->
            

              <tr>
                <td>Invoice</td>                
                <td>
                  <span class="label2"><mat-label>{{getControlLabel('voucherNumberCtrl')}}</mat-label></span>
                </td>
              </tr>
            </table>         
       

          <p class="table-headers">Seneca Admin</p>

          <table>
            <tr>
              <td>Admin Name</td>
              <td><label>{{getControlLabel('approvedByNameCtrl')}}</label></td>
            </tr>

            <tr>
              <td>Date Approved/Rejected</td>
              <td>
                <span class="label2"><mat-label>{{getControlLabel('approvedDateCtrl')}}</mat-label></span>
              </td>
            </tr>

            <tr>
              <td>Admin Comments</td>
              <td><label>{{getControlLabel('senecaCommentsCtrl')}}</label></td>
            </tr>

          </table>

        </div>

        </div>

        <br />

        <div>
          <button mat-flat-button class="seneca-button" color="primary" (click)="onCancel()">Back</button>
        </div>
      </div>
    </mat-card-content>
    </form>
  </mat-card>
</div>

